import { translate as $t } from "@/i18n/vueI18n";

export function timeAgo(inputDate = new Date()) {
  let date;
  if (inputDate instanceof Date) {
    date = inputDate;
  } else if (inputDate && typeof inputDate.toDate === "function") {
    date = inputDate.toDate();
  } else {
    date = new Date(inputDate);
  }
  if (isNaN(date.getTime())) {
    date = new Date();
  }

  let currentDate = new Date();
  let secondsAgo = (currentDate.getTime() - date.getTime()) / 1000;
  let flipped = false;

  if (secondsAgo < 0) {
    flipped = true;
    secondsAgo = secondsAgo * -1;
  }
  if (secondsAgo < 2) {
    return flipped ? $t("global.time.soon") : $t("global.time.just_now");
  }
  if (secondsAgo <= 60) {
    const seconds = Math.round(secondsAgo);
    if (flipped) {
      return (
        $t("global.time.in") +
        " " +
        seconds +
        " " +
        $t("global.time.seconds", seconds)
      );
    }
    return (
      seconds +
      " " +
      $t("global.time.seconds", seconds) +
      " " +
      $t("global.time.ago")
    );
  }
  if (secondsAgo < 60 * 60) {
    const minutes = Math.round(secondsAgo / 60);
    if (flipped) {
      return (
        $t("global.time.in") +
        " " +
        minutes +
        " " +
        $t("global.time.minutes", minutes)
      );
    }
    return (
      minutes +
      " " +
      $t("global.time.minutes", minutes) +
      " " +
      $t("global.time.ago")
    );
  }

  if (secondsAgo < 60 * 60 * 24) {
    const hours = Math.round(secondsAgo / 60 / 60);
    if (flipped) {
      return (
        $t("global.time.in") +
        " " +
        hours +
        " " +
        $t("global.time.hours", hours)
      );
    }
    return (
      hours + " " + $t("global.time.hours", hours) + " " + $t("global.time.ago")
    );
  }

  if (secondsAgo < 60 * 60 * 24 * 7) {
    const days = Math.round(secondsAgo / 60 / 60 / 24);
    if (flipped) {
      return (
        $t("global.time.in") + " " + days + " " + $t("global.time.days", days)
      );
    }

    return (
      days + " " + $t("global.time.days", days) + " " + $t("global.time.ago")
    );
  }

  if (secondsAgo < 60 * 60 * 24 * 31) {
    const weeks = Math.round(secondsAgo / 60 / 60 / 24 / 7);
    if (flipped) {
      return (
        $t("global.time.in") +
        " " +
        weeks +
        " " +
        $t("global.time.weeks", weeks)
      );
    }
    return (
      weeks + " " + $t("global.time.weeks", weeks) + " " + $t("global.time.ago")
    );
  }

  if (secondsAgo < 60 * 60 * 24 * 31 * 12) {
    const months = Math.round(secondsAgo / 60 / 60 / 24 / 31);
    if (flipped) {
      return (
        $t("global.time.in") +
        " " +
        months +
        " " +
        $t("global.time.months", months)
      );
    }
    return (
      months +
      " " +
      $t("global.time.months", months) +
      " " +
      $t("global.time.ago")
    );
  } else {
    const years = Math.round(secondsAgo / 60 / 60 / 24 / 365);
    if (flipped) {
      return (
        $t("global.time.in") +
        " " +
        years +
        " " +
        $t("global.time.years", years)
      );
    }
    return (
      years + " " + $t("global.time.years", years) + " " + $t("global.time.ago")
    );
  }
}
